import { useLocation } from 'react-router-dom';

/**
 * Returns `/clinic` in the JWT admin bundle, `''` in the App Proxy bundle.
 * Use for absolute navigation paths from shared clinic pages.
 */
export function useClinicBasePath(): string {
  const { pathname } = useLocation();
  return pathname.startsWith('/clinic') ? '/clinic' : '';
}
